export enum VirtualPaymentType {
    UPI = 100,
    Alipay = 200,
    PIX = 300,
    BreB = 1300,
    PagoMovil = 1000,
    PagoMovilString = 'PagoMovil',
    SmartRouting = 2
}
export enum PixIdType {
    MobileNumber = 'MobileNumber' ,
    EmailAddress = 'EmailAddress',
    CPFNumber = 'CPFNumber',
    PIXKey = 'PIXKey',
}

export enum PixIdTypeValue {
    MobileNumber = '111801',
    EmailAddress = '111802',
    CPFNumber = '111803',
    PIXKey = '111804',
}

export enum PixIdTypeIntValue {
    MobileNumber = 111801,
    EmailAddress = 111802,
    CPFNumber = 111803,
    PIXKey = 111804,
}

/** GET /recipient/bank-deposit form contract: 2 = single Bre-B key field, no account-type selector. */
export const VPA_FORM_VERSION_SINGLE_FIELD = 2;

export enum BreBIdType {
    Breb = 'BreB',
    MobileNumber = 'MobileNumber',
    EmailAddress = 'EmailAddress',
}

export enum BreBIdTypeValue {
    MobileNumber = '111901',
    EmailAddress = '111902',
}

export enum BreBIdTypeIntValue {
    MobileNumber = 111901,
    EmailAddress = 111902,
}

export enum BrebConfirmationAction {
    Continue = 'continue',
    ChangeKey = 'changeKey',
}

export enum BankPaymentType {
    PagoMovil = "PagoMovil"
}

export enum BankAccountFormatId {
    BankAccountUnitary = 111805,
    BankAccount = 111806,
    PagoMovil = 111809
}


// WEBPACK FOOTER //
// ./src/model/types/vpa-type.ts